import Vue from 'vue'
import VueX from 'vuex'
import routes from './config/AppRoutes'
import axios from "axios"
Vue.prototype.$axios = axios;
// 引入elm
import ElementUI from 'element-ui';
ElementUI.Dialog.props.lockScroll.default = false;
import 'element-ui/lib/theme-chalk/index.css';
// plugins
import VueRouter from 'vue-router'
// import VueBootstrap from 'bootstrap-vue'

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch(err => err);
};

import Print from "vue-print-nb";
Vue.use(Print);

import VueInsProgressBar from 'vue-ins-progress-bar'
import VueCustomScrollbar from 'vue-custom-scrollbar'

// js-cookie
import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie;

// 引入复制单元格
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// plugins css
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-event-calendar/dist/style.css'
import 'simple-line-icons/css/simple-line-icons.css'
import 'flag-icon-css/css/flag-icons.min.css'
import 'ionicons/dist/css/ionicons.min.css'
import "bootstrap-icons/font/bootstrap-icons.css";
// flex
import "./assets/helang-flex.scss";
// iconfont
import './assets/iconfont/iconfont.css'
// color admin css
import './scss/vue.scss'


import App from './App.vue'

// 引入动画插件
import animate from 'animate.css'
Vue.use(animate)

// 引入swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

import VueAMap from "vue-amap"

Vue.use(VueAMap)

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

import 'default-passive-events';

// 获取video
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(VideoPlayer)


// 消息只提示一次
import {
	message
} from '@/utils/resetMessage';

Vue.use(ElementUI)
//挂载
Vue.prototype.$message = message;

Vue.use(VueX)
Vue.use(VueRouter)
// Vue.use(VueBootstrap)

// Vue.use(VueEventCalendar, {
// 	locale: 'en'
// })


Vue.use(VueInsProgressBar, {
	position: 'fixed',
	show: true,
	height: '3px'
})


Vue.component('vue-custom-scrollbar', VueCustomScrollbar)


// 引入vuex
import store from "@/store/index.js"


// t图标自适应
// 定义全局指令

Vue.directive('preventReClick', {
	inserted(el, binding) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true
				setTimeout(() => {
					el.disabled = false
				}, binding.value || 2000)
			}
		})
	}
})

// 动态设置权限设置
Vue.directive('powershow', {
	bind(el, binding) {
		try {
			binding.value.powershows.forEach(item => {
				if (item.path == binding.value.routers && item.title == el.innerText) {
					// console.log("当前页面有显示权限")
					el.style.display = "block"
					throw new Error("跳出循环")
				} else {
					// console.log("当前页面没有显示权限")
					el.style.display = "none"
				}
			})
		} catch (e) {
			// console.log(e)
		}
	},
	update(el, binding) {
		try {
			binding.value.powershows.forEach(item => {
				if (item.path == binding.value.routers && item.title == el.innerText) {
					// console.log("当前页面有显示权限")
					el.style.display = "block"
					throw new Error("跳出循环")
				} else {
					// console.log("当前页面没有显示权限")
					el.style.display = "none"
				}
			})
		} catch (e) {
			// console.log(e)
		}
	}

})


const router = new VueRouter({
	mode: 'hash',
	routes,
	base: "/yunxuexipingtai",
	// 切换路由后滚动条置顶
	scrollBehavior() {
		return {
			x: 0,
			y: 0
		}
	}
})


new Vue({
	render: h => h(App),
	router,
	store,
	axios
}).$mount('#app')


// import SlideVerify from 'vue-monoplasty-slide-verify';
// Vue.use(SlideVerify);
// import VueHljs from 'vue-hljs'
// import hljs from "highlight.js";
// import 'vue-hljs/dist/style.css'
// import VueMaskedInput from 'vue-maskedinput'
// import VueInputTag from 'vue-input-tag'
// import VueSlider from 'vue-slider-component'
// import VueApexCharts from 'vue-apexcharts'
// import VueColorpicker from 'vue-pop-colorpicker'
// Vue.component('masked-input', VueMaskedInput)
// Vue.component('input-tag', VueInputTag)
// Vue.component('vue-slider', VueSlider)
// Vue.component('apexchart', VueApexCharts)
// Vue.use(VueHljs, {
// 	hljs
// })
// import VueCountdown from '@chenfengyuan/vue-countdown'
// import VueGoodTable from 'vue-good-table'
// Vue.use(VueSweetalert2)
// Vue.use(VueGoodTable)
// Vue.use(VueColorpicker)
// import 'vue-good-table/dist/vue-good-table.css'
// import 'vue-select/dist/vue-select.css'
// import 'vue-slider-component/theme/antd.css'
// import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
// import 'sweetalert2/dist/sweetalert2.min.css'
// import 'vue-custom-scrollbar/dist/vueScrollbar.css'
// import 'bootstrap-social/bootstrap-social.css'